// Location Management Constants

export const LOCATION_MANAGEMENT_ROLES = ["BO", "BU", "PC", "PCU", "PCSU"];

export const PARTICIPANT_MODE = {
  EXISTING: "existing",
  NEW: "new",
};

export const LOCATION_COUNTRY_OPTIONS = [
  { label: "US", value: "US" },
  { label: "CA", value: "CA" },
];

export const LOCATION_FIELD_GRID_SIZE = { xs: 12, sm: 6, lg: 3 };

export const LOCATION_RADIUS_MIN = 1;
export const LOCATION_RADIUS_MAX = 50;

export const TARGETING_TYPE = {
  RADIUS: "radius",
  ZIP: "zip",
  RADIUS_AND_ZIP: "radius_and_zip",
};

export const TARGETING_TYPE_OPTIONS = [
  { label: "Radius", value: TARGETING_TYPE.RADIUS },
  { label: "Zip Codes", value: TARGETING_TYPE.ZIP },
  { label: "Radius and Zip Codes", value: TARGETING_TYPE.RADIUS_AND_ZIP },
];

export const getTargetingTypeLabel = (value) =>
  TARGETING_TYPE_OPTIONS.find((option) => option.value === value)?.label ||
  value ||
  "-";
